import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  insurerBranchAll: [],
  insurerBranch: {},
  currentPage: 1,
  totalPages: 1,
  rowsPerPage: 10,
  sortBy: "name",
  sortOrder: "asc",
};

const insurerBranchSlice = createSlice({
  name: "insurerBranch",
  initialState,
  reducers: {
    setInsurerBranchAll: (state, action) => {
      state.insurerBranchAll = action.payload;
    },
    setInsurerBranch: (state, action) => {
      state.insurerBranch = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setTotalPages: (state, action) => {
      state.totalPages = action.payload;
    },
    setRowsPerPage: (state, action) => {
      state.rowsPerPage = action.payload;
    },
  },
});

export const {
  setInsurerBranchAll,
  setInsurerBranch,
  setCurrentPage,
  setTotalPages,
  setRowsPerPage,
} = insurerBranchSlice.actions;

export default insurerBranchSlice.reducer;
